/**
 * Calculate the last page of a pagination component
 *
 * @method calculateLastPage
 * @param  {number}          count        The total count of items
 * @param  {number}          itemsPerPage The amount of items per page
 * @return {number}                       The calculated last page
 */
export const calculateLastPage = (count, itemsPerPage) =>
    Math.max(0, Math.ceil(count / itemsPerPage)) || 1;

/**
 * Adjust the showcaseCount based on the number of digits in the last page number.
 * Reduces visible page buttons to prevent pagination overflow in constrained containers.
 *
 * @method getAdjustedShowcaseCount
 * @param  {number} baseCount The original showcaseCount
 * @param  {number} lastPage  The total number of pages
 * @return {number}           The adjusted showcaseCount
 */
export const getAdjustedShowcaseCount = (baseCount, lastPage) => {
    if (lastPage <= 0 || baseCount <= 1) return baseCount;
    const digits = String(lastPage).length;
    if (digits <= 2) return baseCount;
    const reduction = digits - 2;
    return Math.max(2, baseCount - reduction);
};
